<template>
  <div class="card" @click="handleClick">
    <img :src="getTypeIcon()" :alt="`template-icon-${type}`" />

    <h3>
      {{
        type === TemplateType.Default
          ? `Crea una plantilla personalizada desde ${ProductName}`
          : "Importar una plantilla HTML personalizada"
      }}
    </h3>

    <p v-if="type === TemplateType.Default">
      Diseña tu propio correo desde cero o personaliza nuestras plantillas predeterminadas para
      adaptarlas a tu estilo y necesidades.
    </p>

    <p v-if="type === TemplateType.Html">
      Importa tu propio diseño HTML para correos únicos y a medida. Asegúrate de que tu código
      cumpla con
      <a href="http://" target="_blank" rel="noopener noreferrer" @click.stop>nuestras pautas</a>
      para obtener los mejores resultados.
    </p>
  </div>
</template>

<script setup lang="ts">
import { TemplateType } from "@/@types/flows/emailTemplates";
import { ProductName } from "@/app/shared/utils/constants";

const props = defineProps<{ type: TemplateType }>();

const emit = defineEmits<{ click: [type: TemplateType] }>();

const getTypeIcon = () => {
  return new URL(
    `../../assets/${props.type === TemplateType.Default ? "default" : "html"}-template-icon.svg`,
    import.meta.url
  ).href;
};

const handleClick = () => emit("click", props.type);
</script>

<style scoped lang="sass">
.card
  display: flex
  flex-direction: column
  align-items: center
  padding: 24px 16px
  box-shadow: 0px 1px 8px 0px #0000001A
  border: 1px solid transparent
  border-radius: 8px
  cursor: pointer

  &:hover
    border-color: #1890FF

h3
  text-align: center
  text-wrap: pretty
  margin: 12px 0 8px
  font-weight: 600
  font-size: 14px
  line-height: 22px

p
  text-align: center
  text-wrap: balance
  color: $gray-8
  font-size: 12px
  line-height: 20px
  margin: 0
</style>
